import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from '../../universal-config';

import '@webnotes/web-editor-build/web-editor.js.css'
import '@webnotes/web-editor-build/theme.js.css'
import '@webnotes/web-editor-build/pdf_viewer.js.css'
import '@webnotes/web-editor-build/image_viewer.js.css'
import '@webnotes/web-editor-build/video_viewer.js.css'
import { AttachmentManagerPlugin } from './attachment-manager-plugin-factory';
import { TasksManagerPlugin } from './tasks-manager-plugin';
import { setIsShowSearch, setNoteFont, showToast } from '../../visual/visual.actions';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { MentionService } from './mention.service';
import { NoteImageViewerService } from './noteImageViewer/NoteImageViewer.service';
import { receiveOutlines } from './outlines/outline.actions';
import { NoteService } from './note.service';
import { MetricsService } from '../../metrics.service';
import {ShareErrorsService} from '../share-errors.service';

const str2ab = (str: string): ArrayBuffer => {
  const buf = new ArrayBuffer(str.length*2)
  const bufView = new Uint8Array(buf)
  for (let i=0, strLen=str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i)
  }
  return buf
}

@Component({
  selector: 'nns-note-text-version-2',
  styles: [`
    :host /deep/ h1 {
      margin: 0.67em 0;
    }
    :host /deep/ h2 {
      margin: 0.83em 0;
    }
    :host /deep/ h3 {
      margin: 1em 0;
    }
    :host /deep/ h4 {
      margin: 1.33em 0;
    }
    :host /deep/ h5 {
      margin: 1.67em 0;
    }
    :host /deep/ h6 {
      margin: 2.33em 0;
    }
    :host {
      display:block;
      color:rgba(0, 0, 0, 0.8);
      position: relative;
    }

    :host-context(.nns-theme-night) /deep/ ul.editor-list li.list-item:before {
      z-index: 0;
    }

    :host-context(.nns-theme-night) /deep/ .editor-title textarea {
      background: transparent;
      color: #fff;
    }

    :host-context(.nns-theme-night) /deep/ .title-text {
      color: #fff;
    }

    :host-context(.nns-theme-night) {
      color: #000;
    }

    :host /deep/ .editor-loader {
      padding-top: 10px;
      font-size: 16px;
      max-width: 950px;
      margin: 0 auto;
    }

    :host /deep/ .editor-body {
        padding: 0 10px;
        font-size: 16px;
    }

    :host /deep/ .nedit-root {
        padding-top: 10px;
    }

    nns-loader{
      margin-top: 40px;
    }

    .nns-load-btn{
      background: #0096A7;
      font-weight: bold;
      color: #fff;
      border: none;
      outline: none;
      padding: 6px 16px;
      border-radius: 16px;
      font-size: 13px;
      line-height: 150%;
      cursor: pointer;
    }

    .nns-load-btn-wrapper{
      position: fixed;
      margin-top: 0;
      top: 0;
      margin-left: -12px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :host-context(.nns-theme-night) /deep/ .editor-loader {
      color: #fff;
    }

    :host-context(.nns-embed) nns-loader{
      position: fixed;
      margin-top: 0;
      top: 0;
      margin-left: -12px;
      width: 100%;
      height: 100%;
    }

    :host-context(.nns-embed__video) /deep/ .editor-body{
      max-width: 100%;
      padding: 0;
    }

    :host-context(.nns-embed__video) /deep/ .compact-view-content{
      display: none;
    }

    :host-context(.nns-embed__video) /deep/ .readonly-mode{
      max-width: 100%;
      padding: 0;
    }

    :host-context(.nns-embed__video) /deep/ .video-player {
      width: 100%;
    }

    :host-context(.nns-embed__video) /deep/ .video-player video {
      width: 100%;
    }

    :host-context(.nns-embed__video) /deep/ .file-wrapper {
      padding: 0;
      margin: 0!important;;
    }

    :host-context(.nns-embed__video) /deep/ .empty-caption {
      display: none;
    }

    :host-context(.nns-embed__video) /deep/ .video-player {
      height: 100vh;
    }
    :host-context(.nns-embed__video) /deep/ .file .video-viewer .video-player video {
      max-height: calc(100vh - 46px);
      height: 100vh;
    }

    :host-context(.nns-embed__video) /deep/ .nns-video-header{
      height: 52px;
      display: flex;
      align-items: center;
      padding: 8px 11px;
      box-sizing: border-box;
      background: linear-gradient(180deg, #fff, transparent);
    }
    :host-context(.nns-embed__video) /deep/ .nns-video-header_logo{
      margin-right: 10px;
    }
    :host-context(.nns-embed__video) /deep/ .nns-video-header_logo img{
      display: block;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
    :host-context(.nns-embed__video) /deep/ .icon-get-nimbus-note{
      display: block;
    }
    :host-context(.nns-embed__video) /deep/ a.nns-video-header_title{
      font-size: 18px;
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: calc(100% - 42px);
      color: rgba(0,0,0, 0.8);
      font-family: 'Noto Sans', Verdana, Helvetica, sans-serif;
    }
    :host-context(.nns-embed__video) /deep/ .video-player[fullscreen="true"] .nns-video-header{
      background: linear-gradient(180deg, #000, transparent);
    }
    :host-context(.nns-embed__video) /deep/ .video-player[fullscreen="true"] a.nns-video-header_title{
      color: #fff;
    }
    :host-context(.nns-embed__video)  /deep/ .editor-body .readonly-mode > *:not(.embed-wrapper.file-wrapper) {
      display: none;
    }
    :host-context(.nns-theme-night) ::ng-deep .video-player-popup-bg{
      background: #292E32!important;
    }
    :host-context(.nns-theme-night) ::ng-deep .nns-advert-title{
      color: #fff;
    }
    :host-context(.nns-theme-night) ::ng-deep .nns-advert-footer{
      color: #fff;
    }
    @media print {
      :host-context(.nns-theme-night) ::ng-deep .nedit-root{
        color: #161616;
      }
    }
  `],
  template: `
    <nns-loader *ngIf="!isEditorReady"></nns-loader>
    <div id="nimbus-editor"></div>
    <div class="nns-load-btn-wrapper" *ngIf="showLoadBtn">
      <div class="nns-load-btn" (click)="onLoadNote()">Click to load note</div>
    </div>
    <nns-note-search
        [hidden]="!visual.isShowSearch"></nns-note-search>
  `
})
export class NoteTextVersion2Component implements OnInit, OnDestroy {
  editorInstance: any;
  // @ts-ignore
  editorResizeObserver: ResizeObserver | null = null;
  isEditorReady: boolean;
  scrollingContainer: HTMLElement;
  hash;
  copyEventsCount = 0;
  showLoadBtn = false;
  @Input() note;
  @Input() attachments;
  @Input() share;
  @Input() visual;
  @Input() branding;
  @Input() profile;

  constructor(
    public _elementRef: ElementRef,
    @Inject('isBrowser') public isBrowser: boolean,
    public _router: Router,
    public config: Config,
    public _store: Store<IAppState>,
    private _shareErrorsService: ShareErrorsService,
    private mentionService: MentionService,
    private noteImageViewerService: NoteImageViewerService,
    private cdr: ChangeDetectorRef,
    private noteService: NoteService,
    private tasksManager: TasksManagerPlugin,
    private metrics: MetricsService,
  ) { }

  ngOnInit() {
    if (!this.isBrowser) { return }

    if(this.visual.isEmbed) {
      if(this.hasSameParentNote()) {
        this.isEditorReady = true;
        this.showLoadBtn = true;
      } else {
        this.initEditor();
      }
    } else {
      this.initEditor();
    }
    this.setupTasks();
    this.setupAttachments();
  }

  onLoadNote() {
    this.isEditorReady = false;
    this.showLoadBtn = false;
    this.initEditor();
  }

  async initEditor() {
    const Editor = require('@webnotes/web-editor-build');
    const EDITOR_SELECTOR = '#nimbus-editor';
    const OUTLINE_SELECTOR = 'outline-list-item';
    const SOCKET_EDITOR_DOMAIN_AND_PATH = this.config.get('SOCKET_EDITOR_DOMAIN_AND_PATH');
    const SOCKET_EDITOR_PROTOCOL = this.config.get('SOCKET_EDITOR_PROTOCOL');
    const SOCKET_EDITOR_CONSTANT_DOMAIN = this.config.get('SOCKET_EDITOR_CONSTANT_DOMAIN');
    const DUMP_SERVER_URL = this.config.get('DUMP_SERVER_URL');
    const FEATURES = (this.config.get('FEATURES') || '').split(',');

    this.scrollingContainer = document.querySelector('nns-app');

    let providerConfig = {
      disconnectWhenSynced: true,
      connectToSocket: true
    }

    let dump

    const loadBy = FEATURES.includes('dump') ? 'dump' : 'ws'
    const loadTimeStart = performance.now()

    if (FEATURES.includes('dump')) {
      if (this.share.dump) {
        // декодируем дам из стейта
        dump = new Uint8Array(str2ab(atob(this.share.dump)))
      } else {
        // подгружаем дамп в бинарном виде
        let dumpUrl = `/dump/share/${this.share.id}/${this.share.securityKey}`
        if (this.share.note) {
          dumpUrl += `/${this.share.note}`
        }
        dump = await Editor.getDumpByURL(dumpUrl, {
          headers: {
            'everhelper-session-id': this.getCookie('eversessionid')
          }
        });
      }
      providerConfig.connectToSocket = false
      providerConfig.disconnectWhenSynced = false
    }

    Editor.initEditor({
      element: EDITOR_SELECTOR,
      noteId: this.note.globalId,
      workspaceId: this.note.workspaceId,
      shareId: this.share.id,
      securityKey: this.share.securityKey,
      mode: 'readonly',
      blots: this.getEditorBlots(),
      plugins: this.getEditorPlugins(),
      showLinkPanel: false,
      scrollingContainer: this.scrollingContainer,
      baseUrl: this.getBaseUrl(),
      isShare: true,
      providerConfig,
      ...(dump ? { dump } : {}),
      getSocketUrlFunction: ({
        nodeId,
        workspaceId,
        textId,
        cid,
      }) => {
        if (SOCKET_EDITOR_CONSTANT_DOMAIN) {
          return (token) => `${SOCKET_EDITOR_PROTOCOL}${SOCKET_EDITOR_DOMAIN_AND_PATH}/${workspaceId}/${textId}?token=${token}&cid=${cid}`
        } else {
          return (token) => `${SOCKET_EDITOR_PROTOCOL}text-${nodeId}.${SOCKET_EDITOR_DOMAIN_AND_PATH}/${workspaceId}/${textId}?token=${token}&cid=${cid}`
        }
      },
      onEditorInit: (editorInstance) => {
        if (!this.isSafariBrowser() && !this.isMobileSafariBrowser() && !this.isFacebookApp()) { return }
        this.editorInstance = editorInstance;
        this.noteService.setEditorInstance(editorInstance);
        this.isEditorReady = true;
        this.cdr.detectChanges();
      }
    }).then((editorInstance) => {
      this.editorInstance = editorInstance;
      this.noteService.setEditorInstance(editorInstance);
      if (editorInstance.plugins.editorStyle) {
        this.setTitleFont(editorInstance.plugins.editorStyle.getStyle().style);
      }
      if (editorInstance.plugins.outlineManager) {
        this._store.dispatch(receiveOutlines(editorInstance.plugins.outlineManager.getOutlineData()));
      }
      if (editorInstance.plugins.ctaManager) {
        editorInstance.plugins.ctaManager.setCta(this.share.ctaItems)
      }
      this.isEditorReady = true;
      this.cdr.detectChanges();
      this.noteService.scrollToHash();
      window.addEventListener('keydown', this.catchSearchHotKeys.bind(this));
      if (this.visual.isWordpress) {
        this.initResizeObserver(EDITOR_SELECTOR);
      }
      // отправляем метрику за какое время загрузилась заметка в редакторе
      this.metrics.sendTiming(`share_init_editor_${loadBy}`, +(performance.now() - loadTimeStart).toFixed(0))
      if (window['_shareStartLoad']) {
        this.metrics.sendTiming('share_page_load_content', Date.now() - window['_shareStartLoad'])
      }
    })
  }

  sendNoteLoadMetrics(time, loadBy) {
    const statsdProxy = this.config.get('STATSD_PROXY')
    if (this.config.get('N_ENV') !== 'prod' || !statsdProxy)  return false;
    const statsdUrl = `${statsdProxy}/timing/share_init_editor_${loadBy}`
    fetch(statsdUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      body: `time=${time}`
    })
  }

  initResizeObserver(selector: string) {
    const $element = document.querySelector(selector);
    const message = 'editor:resize';
    const getValue = (el) => ({ height: el.clientHeight, shareId: this.share.id, noteId: this.share.note });
    const getMessage = (message) => ({ message, value: getValue($element) });
    const postMessage = () => window.top.postMessage(getMessage(message), '*');
    const debug = () => console.log('[shared note] postMesage:', getMessage(message));
    const onResize = () => { postMessage(); debug(); };
    // @ts-ignore
    this.editorResizeObserver = new ResizeObserver(onResize);
    this.editorResizeObserver.observe($element);
    onResize();
  }

  initOutlineClickObserver() {
    const elements = document.querySelectorAll(".outline-list-item");
    Array.prototype.forEach.call(elements, (element) => {
      element.removeEventListener('mousedown', this.outlineClickHandler.bind(this), false)
      element.addEventListener('mousedown', this.outlineClickHandler.bind(this), false)
    })
  }

  outlineClickHandler(event) {
    const message = 'editor:outline';
    const getTop = (el) => ({ top: this.getElementOffsetPosition(el) });
    const getMessage = (message, element) => ({ message, value: getTop(element) });
    const debug = (element) => console.log('[shared note] postMesage:', getMessage(message, element));
    const postMessage = (element) => window.top.postMessage(getMessage(message, element), '*');
    const outlineClick = (element) => { postMessage(element); debug(element) }

    const hrefElement = event.target.nodeName.toLowerCase() === 'a' ? event.target : event.target.childNodes[0];
    let href = hrefElement.hash;
    outlineClick(document.getElementById(href.split('#')[1]));
  }

  initOutlineHeaderClickObserver() {
    // @ts-ignore
    document.querySelectorAll('.outline-header').forEach((element) => {
      element.addEventListener('mousedown', (event) => {
        setTimeout(() => {
          this.initOutlineClickObserver();
        }, 150)
      })
    })
  }

  getElementOffsetPosition(element) {
    let offsetTop = 0;
    do {
      offsetTop  += element.offsetTop;
    } while (element = element.offsetParent);
    return offsetTop;
  }

  hasSameParentNote(){
    let currentUrl = null;
    let parent = null;
    try {
      parent = window.parent;
      currentUrl = this.getWindowUrl(window);
    } catch(err) { }

    if(!parent || !currentUrl) {
      return false;
    }

    const parents = [];

    try {
      while (parent != parent.parent) {
        parents.push(parent);
        parent = parent.parent;
      }
    } catch(err) { }

    if(parents.length) {
      return parents.some((parentItem) => {
        try {
          const parentItemUrl = this.getWindowUrl(parentItem);
          return parentItemUrl == currentUrl;
        } catch(err) {
          return false;
        }
      })
    } else {
      return false;
    }
  }

  getWindowUrl(window) {
    const location =  window.location;
    return location.origin + location.pathname;
  }

  ngOnChanges(changes) {
    if(changes && changes.visual && changes.visual.currentValue) {
      const theme = changes.visual.currentValue.theme;
      if(this.editorInstance && this.editorInstance.plugins) {
        if(theme == 'day') {
          this.editorInstance.plugins.editorStyle.setTheme('light')
        } else {
          this.editorInstance.plugins.editorStyle.setTheme('dark')
        }
      }
    }
  }

  private getEditorBlots() {
    const { default: PdfViewer } = require('@webnotes/web-editor-build/pdf_viewer.js')
    const { VideoViewer, getVideoTypes } = require('@webnotes/web-editor-build/video_viewer.js')
    const showAdvert = this.getIsShowAdvert();

    const fileBlot = {
      getAdvert: () => {
        return this.getAdvertHTML();
      },
      showVideoEditButton: this.profile && this.share.currentUserCanEdit,
      viewers: [{
        mime: ['application/pdf'],
        class: PdfViewer,
        options: {
          workerPath: '/static/assets/pdf_viewer.worker.js',
          allowOpenOnMouseOver: true
        },
      },{
        mime: getVideoTypes(),
        class: VideoViewer,
        options: {
          showVideoHeader: this.visual && (this.visual.isEmbed && this.visual.isVideo),
          videoHeaderHTML: this.getVideoHeaderHTML(),
          advert: showAdvert,
        },
      }],
    };

    const imageBlot = {
      processEnterFullSize: (attachment) => {
        if (this.noteImageViewerService.setImage(attachment.attachmentURL)) {
          return this.noteImageViewerService.showImage()
        }

        return false
      },
      disableResize: false,
    };

    const listBlot = {
      collapsible: true,
    };

    const gridBlot = {
      flatten: this.visual.isMobile,
    };

    const tableBlot = {
      floatingHeaderOffset: 59,
    }

    return {
      file: fileBlot,
      image: imageBlot,
      list: listBlot,
      grid: gridBlot,
      table: tableBlot,
    }
  }

  private getEditorPlugins() {
    const FEATURES = (this.config.get('FEATURES') || '').split(',');

    let tasksPluginSettings: { tasksManager?: any; boardManager?: any; } = {}
    if (FEATURES.includes('tasks-bundle')) {
      tasksPluginSettings = {
        tasksManager: {
          featWorkspaceTasksInputs: {
            workspaceContext: {
              workspaceId: this.share.workspaceId,
            },
            nimDetailedViewFloating: true,
            nimAllowedActions: this.getTasksAllowedActions(this.share.currentUserCanEditTasks),
            nimHideComments: !this.share.currentUserCanEditTasks,
            nimHideAttachments: true,
            nimMobileView: this.visual.isMobile
          },
          featWorkspaceTasksOutputs: {}
        },
        boardManager: {
          enabled: true,
          featBoardInputs: {
            nimSkeletonUrl: this.visual.theme === 'day'
              ? './dist/assets/board-skeleton-light.gif'
              : './dist/assets/board-skeleton-dark.gif',
            nimAllowedActions: this.getTasksAllowedActions(this.share.currentUserCanEditTasks),
            nimHideComments: !this.share.currentUserCanEditTasks,
            nimHideAttachments: true,
            nimMobileView: this.visual.isMobile
          },
          featBoardOutputs: {}
        }
      }
    } else {
      this.tasksManager.setup({
        shareId: this.share.id,
        shareSecurityKey: this.share.securityKey
      })
      tasksPluginSettings = { tasksManager: this.tasksManager }
    }

    const { AttachmentNotFoundError } = require('@webnotes/web-editor-build');
    return {
      attachmentManager: new AttachmentManagerPlugin(
        this.attachments,
        AttachmentNotFoundError,
        this._shareErrorsService,
        this.config.get('SHARE_API_SERVICE'),
        this.config.get('GATEWAY_URL'),
        this.config.get('BOX_URL'),
        this.share.workspaceId,
        this.share.noteGlobalId,
        this.share.id,
        this.share.securityKey,
        `${ window.location.origin }${ this.config.get('VIDEO_EDIT_URL') }`,
        this.getShareUrl(),
        this.visual.isWordpress,
        this.note.globalId
      ),
      mentionManager: {
        onMentionClick: (objectType, objectId) => this.mentionService.onMentionClick(objectType, objectId, this.getEmbedInfo()),
        getMentionTitle: this.mentionService.getMentionTitle.bind(this.mentionService),
        updateMentionTitles: this.mentionService.updateMentionTitles.bind(this.mentionService),
      },
      selectionScroller : {
        scrollingContainer: this.scrollingContainer,
        bottomMargin: 20,
      },
      scrollSaver: {
        scrollingContainer: this.scrollingContainer,
        addOffsetTop: 130,
      },
      linkManager: {
        processNavigation: (url: string) => {
          if (this.isFolderUrl(url)) {
            this.goToShare(url);
            return true;
          }

          if (this.isNotesUrl(url) && !this.isSameNoteUrl(url)) {
            this.goToShare(url);
            return true;
          }

          if (this.isShareUrl(url)) {
            const { domain, id, securityKey, hash } = this.getShareUrlConfig(url)

            if (!securityKey) {
              return false;
            }

            if (this.isUrlInternal(url) && hash) {
              this.noteService.scrollToHash(hash);
              return true;
            }

            const shareUrl = this.mentionService.getShareUrl(
              domain,
              { id, securityKey },
              this.getEmbedInfo(),
              hash
            )

            this.mentionService.navigate(shareUrl, '_self')
            return true;
          }

          const { hash } = new URL(url);
          if (!hash) return false;
          if (!this.isSameNoteUrl(url) && !this.isUrlInternal(url)) return false;
          this.noteService.scrollToHash(hash);
          return true;
        },
      },
      ...tasksPluginSettings,
      blockMenu: {
        showCopyBlotButton: !this.visual.isMobile && this.branding.sharesCopyBlotLinkIcon && !this.visual.isEmbed,
      },
      notificationManager: {
        toast: (message: string) => {
          if(message == 'Copied!') {
            this.showCopiedToast();
          }
        }
      },
      copyManager: {
        nimbusOpsEnabled: true,
      },
      search: {
        container: () => document.querySelector('nns-note-search'),
        onSearchStart: () => {
          this._store.dispatch(setIsShowSearch(true));
          setTimeout(() => {
            const input : HTMLInputElement = document.querySelector('nns-note-search input');
            input.focus();
          })
        },
        onSearchEnd: () => {
          this._store.dispatch(setIsShowSearch(false));
        },
      },
      outlineManager: {
        updateOutlineData: (data) => {
          if (this.visual.isWordpress) {
            this.initOutlineClickObserver();
            this.initOutlineHeaderClickObserver();
          }
          return data
        }
      },
      ctaManager: {
        enabled: true,
      },
      signature: {
        verify: true,
        publicKey: this.config.get('SIGN_PUBLIC_KEY')
      }
    }
  }

  getTasksAllowedActions(userCanEdit: boolean) {
    if (userCanEdit) {
      return {
        boardCreate: true,
        boardUpdate: true,
        taskListCreate: true,
        taskListUpdate: true,
        taskListNoteNavigate: true,
        taskListNoteUpdate: true,
        taskCreate: true,
        taskUpdate: true,
        taskDelete: true,
        taskDuplicate: true,
        taskCopy: true,
        taskStatusChange: true,
        taskLabelAdd: true,
        taskLabelDelete: true,
        workspaceLabelCreate: true,
        workspaceLabelUpdate: true,
        taskAssigneeCreate: true,
        taskAssigneeDelete: true,
        taskReminderCreate: true,
        taskReminderDelete: true,
        taskCommentAdd: true,
        taskDescriptionEdit: true,
        taskAttachmentAdd: true,
        taskAttachmentDelete: true,
        membersInvite: false,
        taskListDelete: false,
        taskListConvertToBoard: false,
        boardDelete: false,
        taskCopyLink: false,
        taskConvertToTaskList: false,
        taskDragNDrop: false,
        taskListDragNDrop: false,
        workspaceLabelDelete: false,
        calendarDefaultViewChange: false,
      }
    }
    return {};
  }

  getIsShowAdvert() {
    const share = this.share;
    if(share.ownerIsPremium
      || this.visual.isEmbed
      || this.visual.isMobile
    ) {
      return false;
    } else {
      return true;
    }
  }

  getShareUrlConfig(url) {
    const _url = new URL(url);
    const separator = url.includes('/s/share') ? '/s/share/' : '/share/'; // Legacy /s/ prefix support
    let path = _url.pathname;
    path = path.substring(separator.length);
    let id = path.substring(0, path.indexOf('/'));
    let securityKey = '';
    if (id) {
      path = path.substring(id.length + 1);
      securityKey = path;
    } else {
      id = path;
    }

    return {
      domain: _url.origin,
      id,
      securityKey,
      hash: _url.hash,
    }
  }

  getEmbedInfo() {
    return {
      isEmbed: this.visual.isEmbed,
      isWordpress: this.visual.isWordpress,
      isEmbedPrintEnabled: this.visual.isEmbedPrintEnabled,
      embedHideHeader: this.visual.isEmbedHeaderHidden,
      theme: this.visual.theme,
    }
  }

  getBaseUrl() {
    const { origin, pathname} = window.location;
    return origin + pathname;
  }

  getVideoHeaderHTML() {
    const websiteUrl = this.getShareDomainUrl();
    const noteUrl = this.getShareUrl();
    const title = this.note ? this.note.title : '';
    const img = this.getVideoImg();
    return `<div class="nns-video-header">
              <a href="${websiteUrl}" target="_blank" class="nns-video-header_logo">
                ${img}
              </a>
              <a href="${noteUrl}" target="_blank" class="nns-video-header_title">${title}</a>
            </div>`;
  }

  getShareDomainUrl() {
    const org = this.share.org;
    if(org && org.domain) {
      return `https://${org.domain}`;
    } else if(org && org.sub) {
      const authUrl = this.config.get('NIMBUS_DOMAIN');
      return `https://${org.sub}.${authUrl}`;
    } else {
      const nimbusUrl = this.config.get('NIMBUS_URL');
      return `${nimbusUrl}`;
    }
  }

  getShareUrl() {
    return this.getShareDomainUrl() +  this.note.nnShareUrl;
  }

  getVideoImg() {
    const fileUrl = this.config.get('BOX_URL') + '/file/';
    if(this.branding && this.branding.sharesLogoStoredFileUUID) {
      return `<img src="${fileUrl}${this.branding.sharesLogoStoredFileUUID}"/>`;
    } else if (this.share.instance && this.share.instance.org && this.share.instance.org.smallLogoStoredFileUUID) {
      return `<img src="${fileUrl}${this.share.instance.org.smallLogoStoredFileUUID}"/>`;
    } else {
      return `<nns-icon icon="get-nimbus-note" class="icon-get-nimbus-note"></nns-icon>`;
    }
  }

  getAdvertHTML() {
    return `
      <style>
        .nns-advert{
          text-align: center;
        }
        .nns-advert-logo{
          margin-bottom: 18px;
          display: flex;
          justify-content: center;
        }
        .nns-advert-logo nns-icon{
          display: block;
          width: 40px;
          height: 40px;
        }
        .nns-advert-title{
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 18px;
          color: rgba(38, 47, 86, 1);
        }
        .nns-advert-btn{
          background: #00ACC1;
          padding: 6px 30px;
          border-radius: 30px;
          font-size: 13px;
          color: #fff!important;
        }
        .nns-advert-footer{
          margin-top: 18px;
          font-size: 14px;
          color: #262F56;
        }
        .nns-advert-footer a{
          color: #00ACC1;
          font-weight: bold;
        }
      </style>
      <div class="nns-advert">
        <div class="nns-advert-logo">
            <nns-icon icon="nimbusnote_colored" class="icon-nimbusnote_colored"></nns-icon>
        </div>
        <div class="nns-advert-title">With Nimbus, you can share anything <br> and explain faster than typing</div>
        <a href="https://nimbusweb.me/screenshot.php" target="_blank" class="nns-advert-btn">Get Started for Free</a>
        <div class="nns-advert-footer">
            <span>Find out more at <a href="https://nimbusweb.me/" target="_blank">www.nimbusweb.me</a></span>
        </div>
      </div>`;
  }

  setTitleFont(font) {
    this._store.dispatch(setNoteFont(font));
  }

  showCopiedToast() {
    this._store.dispatch(showToast({
      id: ++this.copyEventsCount,
      text: 'Copied',
      position: 'right',
    }));
  }

  catchSearchHotKeys(event) {
    if(event.ctrlKey && event.code == "KeyF") {
      event.preventDefault();
      this.noteService.startSearch();
    }
  }

  private setupTasks() {
    const setupApiEvent = new CustomEvent('ng2:tasks:setup-api', {
      detail: {
        gatewayUrl: '/gwapi2',
        gatewayToken: this.getCookie('eversessionid'),
        staticAssetPrefix: `${ this.config.get('BOX_URL') }/file/`,
        userId: this.profile ? this.profile.userId : undefined,
        userRole: 'member',
        workspaceId: this.share.workspaceId,
        orgId: this.share.org.globalId,
        skipLoadStartData: true,
      },
    });
    document.dispatchEvent(setupApiEvent);

    console.log('before setup share', this.share)
    const loadAllEvent = new CustomEvent('ng2:tasks:load-by-share', {
      detail: {
        workspaceId: this.share.workspaceId,
        shareId: this.share.id,
        securityKey: this.share.securityKey,
        nodeId: this.share.note,
      },
    });

    document.dispatchEvent(loadAllEvent);
  }

  private setupAttachments() {
    const setupApiEvent = new CustomEvent('ng2:attachments:setup-api', {
      detail: {
        gatewayUrl: '/gwapi2',
        gatewayToken: this.getCookie('eversessionid'),
        staticAssetPrefix: `${ this.config.get('BOX_URL') }/file/`,
      },
    });
    document.dispatchEvent(setupApiEvent);
  }

  private getCookie(keyName: string): string {
    const values = {}
    document.cookie.split('; ').forEach(item => {
      const [key, value] = item.split('=')
      values[key] = value
    })
    return values[keyName]
  }

  private isSafariBrowser() {
    return navigator.vendor == 'Apple Computer, Inc.'
  }

  private isMobileSafariBrowser() {
    const ua = window.navigator.userAgent;
    return ua.match(/iPad/i) || ua.match(/iPhone/i);
  }

  private isUrlInternal(url: string): boolean {
    const { host: myHost, pathname: myPath } = window.location
    const { host: urlHost, pathname: urlPath } = new URL(url)
    const isSameHost = urlHost === myHost
    const isSamePath = myPath == urlPath;
    return isSameHost && isSamePath;
  }

  private isSameNoteUrl(url) {
    const currentNoteId = this.share.note;
    return url.includes('/note/') && url.includes(currentNoteId);
  }

  private isNotesUrl(url) {
    const { pathname } = new URL(url)
    return pathname.startsWith('/ws') && pathname.includes('/note');
  }

  private isFolderUrl(url) {
    const { pathname } = new URL(url)
    return pathname.startsWith('/ws') && pathname.includes('/folder') && !pathname.includes('/note');
  }

  private isShareUrl(url) {
    return url.includes('/share/');
  }

  private goToShare(url) {
    const { pathname, hash } = new URL(url);
    var path = pathname.split('/')
    const params = {workspaceId: null, noteId: null, isFolder: false};
    path.forEach((item, index) => {
      if(item === 'ws') params.workspaceId = path[index + 1];
      if(item === 'folder') {
        params.noteId = path[index + 1];
        params.isFolder = true;
      }
      if(item === 'note') {
        params.noteId = path[index + 1];
        if(params.isFolder) params.isFolder = false;
      }
    })

    if(params.workspaceId && params.noteId) {
      this.mentionService.toNode(params.workspaceId, params.noteId, params.isFolder, this.getEmbedInfo(), hash)
    }
  }

  private isFacebookApp() {
    const ua = navigator.userAgent;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
  }

  ngOnDestroy() {
    this._store.dispatch(receiveOutlines([]));
    if(this.isBrowser) {
      window.removeEventListener('keydown', this.catchSearchHotKeys);
      this.noteService.startSearch(true)
      if (this.editorResizeObserver) {
        this.editorResizeObserver.disconnect();
        this.editorResizeObserver = null;
      }
    }
  }
}
